export interface IQuery { }

export class LastRunsForPipelineByUserQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Runs.Queries.LastRunsForPipelineByUserQueryV1, TCh.Domain.Integrations'

	PipelineId: string
	UserId: string
	Rebuild: boolean

	constructor (pipelineId: string, userId: string, rebuild: boolean)
	{
		this.PipelineId = pipelineId
		this.UserId = userId
		this.Rebuild = rebuild
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Runs.Queries.LastRunsForPipelineByUserQueryV1, TCh.Domain.Integrations'
	}

}

export class LastRunsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Runs.Queries.LastRunsQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string
	Rebuild: boolean

	constructor (organizationUnitId: string, rebuild: boolean)
	{
		this.OrganizationUnitId = organizationUnitId
		this.Rebuild = rebuild
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Runs.Queries.LastRunsQueryV1, TCh.Domain.Integrations'
	}

}

export class RunDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Runs.Queries.RunDetailsQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string
	RunId: string
	Rebuild: boolean

	constructor (organizationUnitId: string, runId: string, rebuild: boolean)
	{
		this.OrganizationUnitId = organizationUnitId
		this.RunId = runId
		this.Rebuild = rebuild
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Runs.Queries.RunDetailsQueryV1, TCh.Domain.Integrations'
	}

}

export class RunsOfOrganizationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Runs.Queries.RunsOfOrganizationQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string

	constructor (organizationUnitId: string)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Runs.Queries.RunsOfOrganizationQueryV1, TCh.Domain.Integrations'
	}

}

